import { Injectable } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";


@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class FilterService<F = null> {
  defaultFilters: F | null;
  filters: F | null;

  setDefaultFilters(filter: F) {
    this.defaultFilters = filter;
    this.filters = filter;
  }

  setFilterField(field: keyof F, value: F[keyof F]) {
    if (this.defaultFilters === null) {
      throw Error("defaultFilters must be sette before use 'setFilterFiled'");
    }

    this.filters = {
      ...this.defaultFilters,
      [field]: value,
    };
  }

  setBulkFilterFields(updatedFilters: Partial<F>) {
    if (this.defaultFilters === null) {
      throw Error("defaultFilters must be sette before use 'setFilterFiled'");
    }

    this.filters = {
      ...this.defaultFilters,
      ...updatedFilters,
    };
  }

  getFilters(): F {
    if (this.filters === null) {
      throw Error("filters must be sette before use 'setFilterFiled'");
    }

    return this.filters;
  }

  getDefaultFilters(): F {
    if (this.defaultFilters === null) {
      throw Error("filters must be sette before use 'setFilterFiled'");
    }

    return this.defaultFilters;
  }

  static staticUpdateFilter<T>(
    field: keyof T,
    value: T[keyof T],
    defaultFilters: T
  ): T {
    return {
      ...defaultFilters,
      [field]: value,
    };
  }

  static staticBulkUpdateFilter<T>(
    updatedFilters: Partial<T>,
    defaultFilters: T
  ): T {
    return {
      ...defaultFilters,
      ...updatedFilters,
    };
  }
}
